module.exports = "//public.getcloudapp.com/packs/media/images/markers/m_1-8eee580840f8ba1b856f64b4aea17607.svg";